import { LicenseState } from '@/enums/licenseState';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-equipment-row',
  templateUrl: './equipment-row.component.html',
  styleUrls: ['./equipment-row.component.css'],
})
export class EquipmentRowComponent {

  @Input() equipmentId: number = 0;
  @Input() index: number = 0;

  @Input() equipmentName: string = '';
  @Input() equipmentBrand: string = '';
  @Input() equipmentModel: string = '';
  @Input() note?: string = '';
  @Input() licenseTypes: string[] = [];
  @Input() conductionZones: string[] = [];
  @Input() expiredAt?: Date | string = new Date();

  // Optional controlled
  @Input() municipalLicenses: string[] = [];
  @Input() state?: string = '';

  constructor() { }

  getStatusColor(status: string) {
    let classList = '';
    switch (status) {
      case LicenseState.VIGENTE:
        classList = 'color-green';
        break;
      case LicenseState.PROXIMO_A_VENCER:
        classList = 'color-yellow';
        break;
      case LicenseState.VENCIDA:
        classList = 'color-red';
        break;
      default:
        classList = 'color-red';
    }
    return classList;
  }

}
